import React from 'react';
import { Highlight } from 'prism-react-renderer';

// Custom dark theme similar to Night Owl
const customTheme = {
  plain: {
    color: '#f1f5f9',
    backgroundColor: '#0f172a',
  },
  styles: [
    {
      types: ['comment', 'prolog', 'doctype', 'cdata'],
      style: {
        color: '#637777',
        fontStyle: 'italic' as const,
      },
    },
    {
      types: ['punctuation'],
      style: {
        color: '#c792ea',
      },
    },
    {
      types: ['property', 'tag', 'boolean', 'number', 'constant', 'symbol', 'deleted'],
      style: {
        color: '#ff6363',
      },
    },
    {
      types: ['selector', 'attr-name', 'string', 'char', 'builtin', 'inserted'],
      style: {
        color: '#c3e88d',
      },
    },
    {
      types: ['operator', 'entity', 'url', 'language-css', 'variable'],
      style: {
        color: '#ffcb6b',
      },
    },
    {
      types: ['atrule', 'attr-value', 'function', 'class-name'],
      style: {
        color: '#82aaff',
      },
    },
    {
      types: ['keyword'],
      style: {
        color: '#c792ea',
        fontStyle: 'italic' as const,
      },
    },
    {
      types: ['regex', 'important'],
      style: {
        color: '#ffcb6b',
      },
    },
  ],
};

export interface SyntaxHighlighterProps {
  code: string;
  language: string;
  className?: string;
}

export const SyntaxHighlighter: React.FC<SyntaxHighlighterProps> = ({
  code,
  language,
  className = ''
}) => {
  return (
    <Highlight
      theme={customTheme}
      code={code.trim()}
      language={language as any || 'text'}
    >
      {({ className: prismClassName, style, tokens, getLineProps, getTokenProps }) => (
        <pre 
          className={`${prismClassName} ${className}`}
          style={{
            ...style,
            backgroundColor: '#0f172a',
            padding: '4rem 1.5rem 1.5rem 1.5rem',
            borderRadius: '0.75rem',
            overflow: 'auto',
            margin: '2rem 0',
            border: '1px solid #334155',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            fontFamily: `'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace`,
            fontSize: '0.875rem',
            lineHeight: '1.6'
          }}
        >
          {tokens.map((line, i) => (
            <div 
              key={i} 
              {...getLineProps({ line, key: i })}
              style={{
                ...(getLineProps({ line, key: i }).style || {}),
                marginTop: i === 0 ? '1rem' : '0'
              }}
            >
              {line.map((token, key) => (
                <span key={key} {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  );
};

export default SyntaxHighlighter;